export function setCookie(name: string, value: string, days: number): void {
	const expiryDate = new Date();
	expiryDate.setDate(expiryDate.getDate() + days);

	document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
		value,
	)}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
}

export function getCookie(name: string): string | null {
	const cookies = document.cookie.split(';');
	const cookieName = `${encodeURIComponent(name)}=`;

	for (let cookie of cookies) {
		cookie = cookie.trim();
		if (cookie.startsWith(cookieName)) {
			return decodeURIComponent(cookie.substring(cookieName.length));
		}
	}

	return null;
}
